import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import { Text, TextStyles } from "@cinch-labs/design-system";
import { LOADING_TEXT } from "../../constants";
import skeletonStyles from "../../skeleton.module.css";
const Title = ({ children , isPending =false , type , className ="" , element ="h5" , ...props })=>/*#__PURE__*/ _jsx(Text, {
        element: element,
        className: cx(skeletonStyles["base"], {
            [skeletonStyles["active"]]: isPending
        }, className),
        type: type || TextStyles.mainTitle,
        ...props,
        children: isPending ? LOADING_TEXT : children
    });
export default Title;
